import { render, staticRenderFns } from "./IndicadoresHistoricoVentas.vue?vue&type=template&id=453c7958&"
import script from "./IndicadoresHistoricoVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoVentas.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoVentas.vue?vue&type=style&index=0&id=453c7958&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports